module.exports = __webpack_public_path__ + "img/haixian.d7ee54e1.png";